import "../../styles/vault.scss";
import locale from "./locales/en";

export { DataCollection } from "@dhx/ts-data";
export { message } from "@dhx/ts-message";
export * from "./Vault";
export * from "./types";

const w = window as any;
export const i18n: any = w.dhx && w.dhx.i18n ? w.dhx.i18 : {};
i18n.setLocale = function(component: string, value: any) {
	const target = i18n[component];
	for (const key in value) {
		target[key] = value[key];
	}
};
i18n.vault = i18n.vault || locale;
